import { BaseService } from '@services/BaseService';

export enum Roles {
  Admin = 'Admin',
  IBSAssociate = 'IBSAssociate',
  IBSManager = 'IBSManager',
  IBSAdmin = 'IBSAdmin',
  AccountingAssociate = 'AccountingAssociate',
  AccountingManager = 'AccountingManager',
  AccountingAdmin = 'AccountingAdmin',
  ServiceAssociate = 'ServiceAssociate',
  ServiceManager = 'ServiceManager',
  ServiceAdmin = 'ServiceAdmin',
  PurchasingAssociate = 'PurchasingAssociate',
  PurchasingManager = 'PurchasingManager',
  PurchasingAdmin = 'PurchasingAdmin',
  AuthorizationAssociate = 'AuthorizationAssociate',
  AuthorizationManager = 'AuthorizationManager',
  AuthorizationAdmin = 'AuthorizationAdmin',
  MarketingAssociate = 'MarketingAssociate',
  MarketingManager = 'MarketingManager',
  MarketingAdmin = 'MarketingAdmin'
}

export class Role {
  public static GetUserRoles() {
    return BaseService.getProfileJSON() && BaseService.getProfileJSON().roles ? BaseService.getProfileJSON().roles : [];
  }

  public static GetAll(): Array<string> {
    return Object.keys(Roles);
  }

  public static CheckRoles(allowedRoles: Array<string>): boolean {
    return allowedRoles.filter(role => this.GetUserRoles()!.indexOf(role) > -1).length > 0;
  }

  public static GetAllIBS(): Array<string> {
    return this.getAllByGroup('IBS');
  }

  public static GetAllAccounting(): Array<string> {
    return this.getAllByGroup('Accounting');
  }

  public static GetAllService(): Array<string> {
    return this.getAllByGroup('Service');
  }

  public static GetAllPurchasing(): Array<string> {
    return this.getAllByGroup('Purchasing');
  }

  public static GetAllAuthorization(): Array<string> {
    return this.getAllByGroup('Authorization');
  }

  public static GetAllMarketing(): Array<string> {
    return this.getAllByGroup('Marketing');
  }

  private static getAllByGroup(groupName: string) {
    return Object.keys(Roles).filter(role => role.indexOf(groupName) > -1);
  }
}



// WEBPACK FOOTER //
// ./src/_models/Roles.ts